import { LEGISLATION_FOLDER } from "./legislation-library-helpers"

function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function findInSubtree(state, rootId, search) {
    const tokens = (search ?? "").toLowerCase().trim().split(/\s+/).filter(Boolean)
    if (!tokens.length) return []
    const root = state.lookup.get(rootId)
    if (!root) return []
    const results = []
    walk(root)
    return results.sort((a, b) => b.score - a.score).map((m) => m.node)

    function walk(node) {
        const name = (node.name ?? "").toLowerCase()
        if (tokens.every((t) => name.includes(t))) {
            results.push({ node, score: scoreMatch(name, tokens) })
        }
        if (node.type !== LEGISLATION_FOLDER) return
        for (const child of node.children) walk(child)
    }
}

function scoreMatch(name, tokens) {
    let score = 0
    for (const t of tokens) {
        if (name === t) score += 100
        else if (name.startsWith(t)) score += 40
        // eslint-disable-next-line security/detect-non-literal-regexp -- token is escaped
        else if (new RegExp(`\\b${escapeRegExp(t)}`).test(name)) score += 15
        else score += 1
    }
    return score
}
